import GridView from "./grid-view";
export default GridView;